import { render, staticRenderFns } from "./CreateSpssExcel.vue?vue&type=template&id=5251c5e6"
import script from "./CreateSpssExcel.vue?vue&type=script&lang=js"
export * from "./CreateSpssExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports